module.exports = __webpack_public_path__ + "static/media/goodfriends.45a20a5c.jpeg";